<template>
  <div style="padding: 30px;">
    <el-form ref="form" :model="form" :rules="rules" label-width="110px">
      <el-row v-if="form.codes">
        <el-col :span="24">
          <el-form-item label="本次付款方式">
            <el-input :placeholder="payTypeTip" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="打款金额">
            <el-input v-model="form.totalAmount" type="number" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="实际承运人运费">
            <el-input v-model="form.totalDriverAmount" type="number" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="服务费">
            <el-input v-model="form.totalTaxAmount" type="number" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            label="支付密码"
            prop="payPassword"
            :rules="[
              { required: true, message: '请输入支付密码', trigger: 'blur' },
              {
                pattern: /^\d{6}$/,
                message: '支付密码必须是6位数字',
                trigger: 'blur'
              }
            ]"
          >
            <el-input
              v-model="form.payPassword"
              type="password"
              maxlength="6"
              :disabled="disabledPSW"
              @input="val => (form.payPassword = val.replace(/\D/g, ''))"
            />
          </el-form-item>
        </el-col>

        <template v-if="needSmsCode">
          <el-col :span="20">
            <el-form-item
              label="获取验证码"
              prop="smsCode"
              :rules="{
                required: true,
                message: `请输入验证码`,
                trigger: 'change'
              }"
            >
              <el-input
                v-model="form.smsCode"
                maxlength="20"
                placeholder="请输入验证码"
              />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <verificationCode
              ref="ishowRef"
              :api-fun="apiFun"
              :query-obj="queryObj"
              @getSms="getSms"
            />
          </el-col>
        </template>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button
        v-if="form.codes"
        type="primary"
        :disabled="disabled || disabledPSW"
        :loading="isLoadingPassword"
        @click="realpay()"
      >
        确认打款
      </el-button>
    </div>
  </div>
</template>
<script>
import request from "@/utils/request";
import { sendVerificationCode } from "@/api/transport";
import {
  applicationForPayment,
  shipmentBalancePaySendSmsCode
} from "@/api/InternetBanking";
import verificationCode from "@/components/verificationCode";
import { verifyPay } from "@/api/pay";
import { Base64 } from "js-base64";
export default {
  name: "PaymentAction",
  components: {
    verificationCode
  },
  data() {
    return {
      cashdisabled: false,
      disabled: true,
      show: true,
      count: "",
      shipmentBalancePaySendSmsCode: "",
      apiFun: "",
      queryObj: {},
      emptyForm: {
        codes: "",
        payType: "",
        totalAmount: "",
        smsCode: "",
        payPassword: ""
      },
      form: {},
      rules: {
        code: [
          { required: true, message: "运单编号不能为空", trigger: "blur" }
        ],
        prepaidAmount: [
          { required: true, message: "请输入预付金额", trigger: "blur" }
        ]
      },
      payTypeTip: "",
      needSmsCode: false,
      totalAmount: "",
      payPassword: "",
      paymentType: "",
      source: "platform",
      disabledPSW: false,
      isLoadingPassword: false
    };
  },
  mounted() {
    this.emptyForm = JSON.parse(JSON.stringify(this.form));
    const partyType = this.$store.getters.party.partyType;
    let isShipment = partyType == "SHIPMENT" || partyType == "SHIPMENT_COMPANY";
    if (isShipment) {
      this.source = "shipment";
    }
  },
  methods: {
    excitPSW(codes) {
      let data = {
        codes: codes
      };
      const rLoading = this.openLoading();

      request({
        url: `/ntocc-basic-api/pay/isexist`,
        method: "get",
        params: data
      }).then(res => {
        if (res.status == 0 && res.data.isHave == "1") {
          // this.payInfo = { codes, paymentType, shipperPhone };
          // this.showPay = true;
          this.disabledPSW = false;
          rLoading.close();
          // return;
        } else {
          this.disabledPSW = true;
          rLoading.close();
          this.$confirm("您还未设置支付密码，请前往设置", "提示", {
            confirmButtonText: "去设置",
            cancelButtonText: "取消",
            type: "warning"
          })
            .then(() => {
              this.$router.push({
                path: "/systemManage/payPassword/addPassword"
              });
            })
            .catch(() => {});
        }
      });
    },
    init(data, shipperPhone, code) {
      this.excitPSW(code);

      this.form = JSON.parse(JSON.stringify(this.emptyForm));
      // 是否需要验证码 使用同一个接口字段
      this.needSmsCode = data.data.needSmsCode == "yes" ? true : false;
      this.form.payType = data.data.payType;
      this.form.totalAmount = data.data.totalAmount;
      this.form.totalDriverAmount = data.data.totalDriverAmount;
      this.form.totalTaxAmount = data.data.totalTaxAmount;
      this.form.codes = code;
      // 中信与网商获取验证码的接口不同 通过 arpa_2 进行区分
      if (this.form.payType == "arpa_2") {
        this.apiFun = sendVerificationCode;
        this.queryObj.source = this.source;
        this.queryObj.amount = this.form.totalAmount;
        this.queryObj.phone = shipperPhone;
      } else {
        this.apiFun = shipmentBalancePaySendSmsCode;
        this.queryObj.codes = code;
      }
      this.payTypeTip = data.msg;
      if (this.needSmsCode) {
        this.disabled = true;
      } else {
        this.disabled = false;
      }
    },
    getSms(data, arg) {
      this.disabled = false;
      this.form.orderNo = data.orderNo;
      this.form.outTradeNo = data.outTradeNo;
    },
    close() {
      this.cashdisabled = false;
      this.count = 0;
      this.disabled = true;
    },
    // 确认提示
    realpay() {
      if (!this.form.payPassword || !/^\d{6}$/.test(this.form.payPassword)) {
        this.$message.error("请输入6位数字支付密码");
        return;
      }
      this.$confirm("确认要打款吗？")
        .then(_ => {
          let data = {
            payPassword: Base64.encode(this.form.payPassword) + ""
          };
          console.log("payPassword", typeof data.payPassword);
          const rLoading = this.openLoading();
          verifyPay(data).then(res => {
            if (res.status == 0) {
              // this.$emit("complete");
              this.payclick();
            }
            rLoading.close();
          });
        })
        .catch(_ => {});
    },
    //确认打款
    payclick() {
      this.$refs["form"].validate(async valid => {
        const notifyInstance = this.$notify({
          title: "提示",
          message: "正在为您处理支付，请稍后",
          duration: 0,
          type: "warning"
        });
        if (valid) {
          const rLoading = this.openLoading();
          try {
            let data = this.form;
            data.payPassword = Base64.encode(this.form.payPassword) + "";
            this.isLoadingPassword = true;
            // this.$message({
            //   message: "支付中，请稍后",
            //   type: "info"
            // });
            let response = await applicationForPayment(data);
            this.isLoadingPassword = false;
            this.show = true;
            this.$emit("closeWindows");
            this.$message.success(response.msg);
            notifyInstance.close();
          } catch (err) {
            this.isLoadingPassword = false;
            console.log("支付异常捕获=========", err);
            notifyInstance.close();
            this.$message({
              message: err.msg || "支付失败，请稍后重试",
              type: "info"
            });
            this.$emit("error", err);
          }

          rLoading.close();

          this.disabled = true;
        }
      });
    },
    //获取验证码
    getCode() {
      let data = {
        codes: this.form.codes
      };
      if (this.form.payType == "") {
        this.$message({
          message: "支付信息有误，请重新打开支付页面",
          type: "warning"
        });
      } else {
        let $this = this;
        const rLoading = $this.openLoading();
        request({
          url: `/ntocc-tms-api/orderDetail/shipmentBalancePaySendSmsCode`,
          method: "post",
          params: data
        }).then(response => {
          rLoading.close();
          $this.$message({
            message: response.msg,
            type: "success"
          });
          $this.disabled = false;
          // $this.form.mybankBalancePayDTO = response.data
          // let form = Object.assign($this.form,$this.form,response.data)
          let data = response.data;
          $this.form.orderNo = data.orderNo;
          $this.form.outTradeNo = data.outTradeNo;
          //console.log($this.form);
          if (response.status == 0) {
            const TIME_COUNT = 60;
            if (!$this.timer) {
              $this.count = TIME_COUNT;
              $this.show = false;
              $this.timer = setInterval(() => {
                if ($this.count > 0 && $this.count <= TIME_COUNT) {
                  $this.count--;
                } else {
                  $this.show = true;
                  clearInterval($this.timer);
                  $this.timer = null;
                }
              }, 1000);
            }
          }
        });
      }
    },
    isFloor(e) {
      e.target.value = e.target.value.match(/^\d*(\.?\d{0,1})/g)[0] || null;
    }
  }
};
</script>

<style lang="scss" scoped>
.dialog-footer {
  float: right;
}
.count,
.smscode {
  height: 40px;
  line-height: 40px;
  display: block;
  padding-left: 5px;
}
</style>
